import { Link, Typography, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import { NavigateNext as NextIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { getUrlWithParams } from '../../utils/Utils';

const CustomBreadcrumb = ({ breadcrumbs }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const newParams = new URLSearchParams(search);
  const selectedCycleId = Number(newParams.get('cycleId'));
  const selectedCycle = newParams.get('cycleName');
  const bu = newParams.get('bu');

  const handleClick = (event, link) => {
    event.preventDefault();
    navigate(getUrlWithParams(link, bu, selectedCycle, selectedCycleId));
  };

  return (
    <MUIBreadcrumbs separator={<NextIcon fontSize="small" />} aria-label="breadcrumb">
      {breadcrumbs.map(({ label, icon, link, isActive }, index) =>
        isActive ? (
          <Typography key={`${index + 1}`} color="#616161">
            {label}
          </Typography>
        ) : (
          <Link
            key={`${index + 1}`}
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            color="#005CBC"
            onClick={(e) => handleClick(e, link)}>
            {icon}
            <Typography variant="body1">{label}</Typography>
          </Link>
        )
      )}
    </MUIBreadcrumbs>
  );
};

export default CustomBreadcrumb;
